import React from 'react';
import { Box, Button, Typography, Container } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const APKDownloadBanner: React.FC = () => {
  const handleDownloadAPK = () => {
    window.location.href = 'https://offer.app20.in/apk';
  };

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)',
        py: { xs: 3, md: 4 },
        my: { xs: 2, md: 3 },
        borderRadius: '12px',
        textAlign: 'center',
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h5"
          sx={{
            color: 'white',
            fontWeight: 'bold',
            mb: 2,
            fontSize: { xs: '18px', md: '24px' },
          }}
        >
          Download App20 APK
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'rgba(255, 255, 255, 0.9)',
            mb: 3,
            fontSize: { xs: '14px', md: '16px' },
          }}
        >
          Download the App20 app to start earning rewards today!
        </Typography>
        <Button
          variant="contained"
          size="large"
          endIcon={<FileDownloadIcon />}
          onClick={handleDownloadAPK}
          sx={{
            backgroundColor: '#FFB300',
            color: '#000',
            fontWeight: 'bold',
            fontSize: { xs: '14px', md: '16px' },
            py: { xs: 1.5, md: 2 },
            px: { xs: 3, md: 4 },
            border: 'none',
            '&:hover': {
              backgroundColor: '#FFA500',
              boxShadow: '0 4px 12px rgba(255, 179, 0, 0.4)',
            },
          }}
        >
          Download APK
        </Button>
      </Container>
    </Box>
  );
};

export default APKDownloadBanner;
